import { supabase } from '@/integrations/supabase/client';

export interface CustomerFeedback {
  id: string;
  venue_id: string;
  customer_id: string;
  game_id?: string;
  event_id?: string;
  rating: number;
  feedback_text?: string;
  visit_date: string;
  created_at: string;
}

export const customerFeedbackService = {
  async submitFeedback(feedbackData: {
    venue_id: string;
    customer_id: string;
    rating: number;
    feedback_text?: string;
    game_id?: string;
    event_id?: string;
    visit_date?: string;
  }): Promise<CustomerFeedback | null> {
    const { data, error } = await supabase
      .from('customer_feedback')
      .insert({
        visit_date: feedbackData.visit_date || new Date().toISOString().split('T')[0],
        ...feedbackData
      })
      .select()
      .single();

    if (error) {
      console.error('Error submitting feedback:', error);
      return null;
    }

    return data;
  },

  async getVenueFeedback(venueId: string): Promise<CustomerFeedback[]> {
    const { data, error } = await supabase
      .from('customer_feedback')
      .select('*')
      .eq('venue_id', venueId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching venue feedback:', error);
      return [];
    }

    return data || [];
  },

  async getCustomerFeedback(customerId: string): Promise<CustomerFeedback[]> {
    const { data, error } = await supabase
      .from('customer_feedback')
      .select('*')
      .eq('customer_id', customerId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching customer feedback:', error);
      return [];
    }

    return data || [];
  }
};